<template>
  <div v-if="store.firstVisit" class="first-visit-overlay" @click="store.firstVisit = false">
    <!-- <div class="first-visit roboto-medium">
      <img src="~@/assets/imgs/chatbot/first-visit-icon.webp" />
      <h3>PATCH NOTES CHAT</h3>
      <p>
        Ask Pink Bean questions about the Patch Notes in the chat window! Pink Bean can only answer your questions about
        updates from the past year (V.246 to V.{{ store.patchNotesVersion }}).
      </p>
    </div> -->
  </div>
</template>

<script lang="ts" setup>
  import { useChatbotStore } from '@/store/Chatbot'

  const store = useChatbotStore()
</script>

<style lang="scss" scoped>
  .first-visit-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .first-visit {
    background-color: white;
    padding: 20px;
    border-radius: 10px;
    font-weight: 700;
    max-width: 440px;
    text-align: center;
    position: relative;
    h3 {
      color: #ff6d00;
      font-size: 32px;
    }
    img {
      position: absolute;
      top: -40px;
      left: -22px;
      aspect-ratio: 1/1;
      width: 20%;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
  }
  @media #{$mobile} {
    .first-visit {
      padding: 10px;
      margin: 30px 10px 10px 20px;
      h3 {
        font-size: 24px;
      }
      img {
        top: -30px;
        left: -15px;
        width: 15%;
      }
      p {
        font-size: 12px;
        line-height: 16px;
      }
    }
  }
</style>
